module.exports = __webpack_public_path__ + "38b952334be016f5c5ff63d2e5617681.svg";